import styled from 'styled-components';

export default styled.div`
	display: grid;
		grid-template-columns: 10fr 1fr;		
		grid-template-areas:
			'content toogle-link';

	.richText-Body {
		grid-area: content;
		word-wrap: break-word;
		word-break: break-word;
		height: auto;
		transition: 0.2s ease-out max-height;
		overflow: hidden;
		display: -webkit-box;		
		-webkit-line-clamp: ${(props) => (!props.isExpanded ? props.noOfLines : '')};
		-webkit-box-orient: vertical;
		padding-right: 1rem;
		ul li {
			margin-left: 1.5rem
			list-style-type: disc;
		}
	}
`;
